import { render, staticRenderFns } from "./FollowArtistPageWrapper.vue?vue&type=template&id=8cd75a56&scoped=true"
import script from "./FollowArtistPageWrapper.vue?vue&type=script&lang=js"
export * from "./FollowArtistPageWrapper.vue?vue&type=script&lang=js"
import style0 from "./FollowArtistPageWrapper.vue?vue&type=style&index=0&id=8cd75a56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd75a56",
  null
  
)

export default component.exports